import { render, staticRenderFns } from "./GenericImport.vue?vue&type=template&id=17823fa5"
import script from "./GenericImport.vue?vue&type=script&lang=js"
export * from "./GenericImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports